import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('Maximum update depth exceeded') ||
     args[0].includes('Warning: Maximum update depth exceeded'))
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
